module.exports = __webpack_public_path__ + "img/sy_4.faa6ca67.png";